var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.31 4.662-1.19 1.19-2.975-2.98 1.19-1.19a.657.657 0 0 1 .907 0l2.069 2.073c.25.25.25.657 0 .907Zm-9.944 9.955-2.975-2.98 7.692-7.702 2.976 2.979-7.693 7.703Zm-3.662-1.543 2.226 2.23-3.1.874.874-3.104ZM17.372 2.693 15.304.62c-.404-.404-1.863-1.168-3.027 0L1.797 11.11a.721.721 0 0 0-.191.327L.026 17.06c-.073.26.004.54.191.735.191.194.573.227.735.19l5.62-1.583a.721.721 0 0 0 .327-.19L17.372 5.723a2.149 2.149 0 0 0 0-3.031Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgPencil;